import React from 'react';

import { Grid } from '@material-ui/core';
import { TextField, Step } from '../SteppedForm';
import rules from './rules';

const StepOperatorReferralDetails = (props) => {
  return (
    <Step
      id="operatorreferraldetails"
      title="Operator Referral Details"
      skip={(formdata) => formdata.onboardingFor === 'vehicle' || formdata.has_referred_by_operator_or_driver === false}>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField
            id="OperatorReferral_Fullname"
            label="Full name of the person who has referred you"
            required/>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="OperatorReferral_Phone"
            label="Their mobile phone number"
            type="tel"
            inputProps={{ maxLength: 16 }}
            valid={rules.phone}
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="OperatorReferral_TPlate"
            label="Their current taxi licence plate"
            required
          />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepOperatorReferralDetails;
